import { createServerFn } from "@tanstack/react-start";
import { fetchMaintenanceComparison } from "@/lib/maintenance-topic.server";

export const getMaintenanceComparison = createServerFn({ method: "GET" }).handler(() =>
  fetchMaintenanceComparison(),
);
